/* eslint-disable @typescript-eslint/naming-convention */
enum TranslatableType {
    STRING = 'STRING',
    LIST = 'LIST',
}

enum TranslationMethod {
    VALUE = 'VALUE',
    CODE_TABLE = 'CODE_TABLE',
    NOT_TRANSLATED = 'NOT_TRANSLATED',
    EXTERNAL_ORGANIZATION = 'EXTERNAL_ORGANIZATION',
}

export interface Translatable<T> {
    translationMap: { [k: string]: T };
    translatableType: TranslatableType;
    translationMethod: TranslationMethod;
}

export const getTranslatableValue = (
    t: Translatable<any>,
    language: string
) => {
    if (t === undefined || t === null) {
        return undefined;
    }
    const ENGLISH_CODE = 'eng';
    const UNKNOWN_CODE = 'und';

    language = language.toLowerCase();
    return (
        t.translationMap?.[language] ??
        t.translationMap?.[UNKNOWN_CODE] ??
        t.translationMap?.[ENGLISH_CODE] ??
        Object.values(t.translationMap)[0]
    );
};
